export const SESSION_FROZEN_KEY = 'sessionFrozen'
export const SESSION_FREEZE_EVENT = 'session-freeze'

// The only proof that a session was deliberately invalidated. The backend sends this code
// solely when a tenant's server-side session generation exists AND disagrees with the
// token -- never for a Redis miss, an expired key or a restart.
export const SESSION_INVALIDATED_CODE = 'SESSION_INVALIDATED'

// A bare 401/403 means "this token will not do" (expired access token, missing header,
// a refresh that failed). It is an ordinary auth failure: sign the user out the normal
// way. Only the explicit code above may raise the "Session updated" flow, so an unrelated
// 401 can never be mistaken for an administrator ending the session.
export const isSessionInvalidationCode = (code) => code === SESSION_INVALIDATED_CODE

// Pulls the invalidation code off an axios error, and only that code. Anything else --
// a different application code, no body, a network error -- reads as "not an
// invalidation" so callers cannot accidentally pass a truthy unrelated reason through.
export const getSessionInvalidationCode = (error) =>
  isSessionInvalidationCode(error?.response?.data?.code) ? SESSION_INVALIDATED_CODE : null

export const DEFAULT_FREEZE_MESSAGE =
  "Your organization's configuration was updated by an administrator. Please refresh the page to continue."

export const freezeSession = (message) => {
  sessionStorage.setItem(SESSION_FROZEN_KEY, '1')
  window.dispatchEvent(
    new CustomEvent(SESSION_FREEZE_EVENT, {
      detail: { message: message || DEFAULT_FREEZE_MESSAGE },
    }),
  )
}

export const isSessionFrozen = () => Boolean(sessionStorage.getItem(SESSION_FROZEN_KEY))

export const clearSessionFrozenFlag = () => sessionStorage.removeItem(SESSION_FROZEN_KEY)

// Set while a frozen session is being torn down (Refresh Page -> logout). Widgets such as the
// notification bell mount before the guard runs, so their calls land mid-logout and come back
// 401. Those failures are expected and the user can do nothing about them, so the axios
// interceptors drop the request and stay quiet until the user is back on the login screen.
let sessionTeardownInProgress = false

export const beginSessionTeardown = () => {
  sessionTeardownInProgress = true
}

export const endSessionTeardown = () => {
  sessionTeardownInProgress = false
}

export const isSessionTeardownInProgress = () => sessionTeardownInProgress
